<div class="universal-dropdown-container" [attr.data-testid]="'universal-dropdown-' + label">
  <mat-form-field
    class="universal-dropdown"
    [floatLabel]="floatLabel()"
    [hideRequiredMarker]="true"
    [subscriptSizing]="dynamicSubscriptSizing() ? 'dynamic' : 'fixed'"
    appearance="outline"
  >
    @if (label) {
      <mat-label>
        <span>
          <span>{{ isRequired ? '*' : '' }}</span
          >{{ label | translate }}
        </span>
      </mat-label>
    }
    <mat-select
      class="dropdown__select"
      #matSelect
      [disabled]="isLoading()()"
      [formControl]="control"
      [placeholder]="placeholder() | translate"
      [disableOptionCentering]="disableOptionCentering()"
      [panelClass]="panelClass()"
      [multiple]="multiple()"
      [compareWith]="compareWith()"
      [attr.data-testid]="selectTestId"
    >
      @if (customInputTrigger) {
        <mat-select-trigger>
          <ng-template [ngTemplateOutlet]="customInputTrigger" [ngTemplateOutletContext]="{ $implicit: value }"></ng-template>
        </mat-select-trigger>
      }
      @if (hasSearchBar()) {
        <mat-form-field class="search-input" appearance="outline" subscriptSizing="dynamic">
          <input
            [placeholder]="('default.search' | translate) + '...'"
            [ngModel]="searchInput"
            (ngModelChange)="onSearch($event)"
            (keydown)="$event.stopPropagation()"
            type="text"
            matInput
          />
        </mat-form-field>
      }

      @if (multiple() && selectAllOption()) {
        <div class="select-all" [class.selected]="isSelectAllSelected">
          <mat-checkbox
            class="select-all-checkbox table-filter-options"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="isSelectAllSelected"
            (ngModelChange)="updateIsSelectAllSelected($event)"
            (change)="toggleAllSelection()"
          >
          </mat-checkbox>
          <span>
            {{ 'default.selectAll' | translate }}
          </span>
        </div>
      }

      @for (option of displayedOptions; track option) {
        <mat-option class="table-filter-options" [value]="valueFn()(option)" [attr.data-testid]="optionTestId" (click)="optionClick()">
          @if (customPreview) {
            <div class="custom-preview">
              <ng-template [ngTemplateOutlet]="customPreview" [ngTemplateOutletContext]="{ $implicit: option }"></ng-template>
            </div>
          } @else {
            <span>
              {{
                additionalTranslationString
                  ? (additionalTranslationString + displayFn()(option) | translate)
                  : (displayFn()(option) | translate)
              }}
            </span>
          }
        </mat-option>
      }

      @for (option of hiddenOptions; track option) {
        <mat-option class="universal-dropdown__option--hidden" [value]="valueFn()(option)"></mat-option>
      }
    </mat-select>
    @if (true) {
      <mat-error [attr.data-testid]="errorTestId || null">{{ 'required.universal-dropdown.field' | translate: { label: label | translate } }}</mat-error>
    }
  </mat-form-field>
</div>
